import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { Row, Col, Divider, Popover, Button, Radio, Space, Input, Tooltip, Breadcrumb, BackTop } from 'antd';
import { PageHeader } from 'components/header';
import { InfoCircleOutlined, SearchOutlined, FilterOutlined, SortAscendingOutlined, DoubleRightOutlined, DownloadOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons';

import { isAuth, _setAxios, getParamTable, getParamTempTableFiltering, _scrollFloatBtn, capitalizeFirstLetter } from '../../../lib/Helper';

import AuthRedirect from '../../../components/AuthRedirect'
import Penangguhan from '../modal/Penangguhan';
import Delete from '../modal/Delete';
import Restore from '../modal/Restore';
import Filter from '../modal/Filter';
import Import from '../modal/Import';
import Export from '../modal/Export';
import Desktop from './Desktop';
import Mobile from './Mobile';


const tableOptions = {
  sorts: [{
    value: "ASC",
    label: "Ascending",
  }, {
    value: "DESC",
    label: "Descending",
  }],
  fields: [{
    value: "id",
    label: "Tanggal Pembuatan",
  }, {
    value: "nama",
    label: "Nama",
  }]
}

class SiswaIndex extends React.Component {

  constructor(props) {
    super(props)
    const { privilege } = this.props
    this.state = {
      values: {},
      table: {
        loading_first: false,
        loading: false,
        data: [],
        search: "",
        pagination: {
          current: 1,
          pageSize: 10,
          total: null,
        },
        sorting: [],
        filtering: {
          status_siswa: window.location.pathname.split("/").pop() === "aktif" ? "Aktif" : "Non Aktif",
          tahun_ajaran_id: privilege?.tahun_ajaran?.id,
          semester_id: privilege?.semester?.id,
          rombel_id: null,
        },
      },
      penangguhan: {
        data: {},
        visible: false
      },
      delete: {
        data: {},
        visible: false
      },
      restore: {
        data: {},
        visible: false
      },
      filter: {
        values: {
          tahun_ajaran_id: privilege?.tahun_ajaran?.id,
          semester_id: privilege?.semester?.id
        },
        visible: false,
      },
      import: {
        values: {},
        visible: false,
      },
      export: {
        values: {},
        visible: false,
      },
    };
  }

  componentDidMount() {
    _scrollFloatBtn()
  }

  fetchTable = (isNew = false) => {
    const { table } = this.state
    const params = getParamTable("default", table)
    this.fetch(params, isNew);
  }

  fetch = async (params = {}, isNew = false) => {
    this.setState({
      table: {
        ...params,
        loading_first: isMobile ? (isNew ? true : false) : false,
        loading: true
      }
    });

    params = {
      ...params,
      pagination: {
        ...params.pagination,
        current: isMobile ? (isNew ? 1 : params.pagination.current) : params.pagination.current
      }
    }
    _setAxios("siswa/table", "POST", params).then(resp => {
      if (resp.status === true) {
        let data = isNew ? [] : this.state.table.data

        let current = params.pagination.current
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
            data: isMobile ? [...data, ...resp.data.list] : resp.data.list,
            pagination: {
              ...params.pagination,
              current: isMobile ? current + 1 : current,
              total: resp.data.info.total
            }
          }
        });
      } else {
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
          }
        })
      }
    })
  };

  handleChangeSetValue = (name, value) => {
    const { values } = this.state;
    this.setForm(values, name, value)
  };

  setForm = (values, name, value) => {
    values[name] = value;

    this.setState({
      values: values,
    });
  }

  setTempTableFilter = (name, value) => {

    let values = this.state.filter.values
    values[name] = value

    this.setState({
      filter: {
        ...this.state.filter,
        values: values
      }
    })

  };

  setTableFilterFromTemp = () => {
    const params = getParamTempTableFiltering(this.state.table, this.state.filter.values)
    this.fetch(params, isMobile ? true : false)
    this.modalFilter(false)
  };
  // FILTER END ------------------------------------------


  modalPenagguhan = (visible = false, data = {}) => {
    this.setState({
      penangguhan: {
        data: data,
        visible: visible
      },
    })
  }

  modalDelete = (visible = false, data = {}) => {
    this.setState({
      delete: {
        data: data,
        visible: visible
      },
    })
  }

  modalRestore = (visible = false, data = {}) => {
    this.setState({
      restore: {
        data: data,
        visible: visible
      },
    })
  }

  modalFilter = (visible = false) => {
    this.setState({
      filter: {
        ...this.state.filter,
        visible: visible,
      },
    })
  }

  modalImport = (visible = false) => {
    this.setState({
      import: {
        ...this.state.import,
        visible: visible
      },
    })
  }
  modalExport = (visible = false) => {
    this.setState({
      export: {
        ...this.state.export,
        visible: visible
      },
    })
  }

  render() {

    const statusSiswa = window.location.pathname.split("/").pop()
    const access = this.props.privilege.access["/peserta-didik/" + statusSiswa]
    if (!isAuth(this.props.privilege) || access === undefined) {
      return <AuthRedirect />
    }
    const action = access.action
    const { table } = this.state;

    const sortComponent = <>
      <Radio.Group onChange={(e) => {
        const params = getParamTable("sort_field", table, e.target.value)
        this.fetch(params, isMobile ? true : false)
      }} value={table.sorting.length > 0 ? table.sorting[0].field : ""} name="sort_field">
        <Space direction="vertical">
          {tableOptions.fields.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
        </Space>
      </Radio.Group>
      <Divider orientation="left"></Divider>
      <Radio.Group onChange={(e) => {
        const params = getParamTable("sort", table, e.target.value)
        this.fetch(params, isMobile ? true : false)
      }} value={table.sorting.length > 0 ? table.sorting[0].sort : ""} name="sort_value">
        <Space direction="vertical">
          {tableOptions.sorts.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
        </Space>
      </Radio.Group>
    </>

    return (
      <>
        <PageHeader
          style={{
            padding: 0
          }}
          onBack={() => window.history.back()}
          subTitle={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
            <Breadcrumb.Item>Peserta Didik</Breadcrumb.Item>
            <Breadcrumb.Item>Peserta Didik {capitalizeFirstLetter(statusSiswa)}</Breadcrumb.Item>
          </Breadcrumb>}
          extra={[
            action.export ? <Button onClick={this.modalExport.bind(this, true)}><DownloadOutlined /> Export</Button> : null,
            action.import ? <Button onClick={this.modalImport.bind(this, true)}><UploadOutlined /> Import</Button> : null,
            action.create ? <Link to={`/peserta-didik/aktif/create`}><Button type='primary'><PlusOutlined /> Tambah</Button></Link> : null
          ]}
        />
        <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
          <PageHeader
            className="site-page-header"
            title={`Peserta Didik ${capitalizeFirstLetter(statusSiswa)}`}
            subTitle={`Data peserta didik ${statusSiswa}`}
          />
          <MobileView>
            <div className='float-btn-center' id='float-btn-center' align='center'>
              <div className="float-btn-div">
                <Popover placement="top" content={sortComponent} trigger="click">
                  <Button type='primary' className='float-btn' icon={<SortAscendingOutlined />}>Urutkan</Button>
                </Popover>
                <Divider type="vertical" className="divider-border-white" />
                <Button type='primary' className='float-btn' icon={<FilterOutlined />} onClick={this.modalFilter.bind(this, true)}>Filter</Button>
              </div>

            </div>
          </MobileView>

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={18} md={19} >
              <Input
                name="search"
                className='search-table'
                placeholder="Search..."
                prefix={<SearchOutlined className="site-form-item-icon" />}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const params = getParamTable("search", table, e.target.value)
                    this.fetch(params, isMobile ? true : false)
                  }
                }}
                suffix={
                  <Tooltip title="Cari berdasarkan nama">
                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                  </Tooltip>
                }
              />
            </Col>
            <Col xs={24} sm={6} md={5}>
              <BrowserView>
                <Button.Group className='ant-btn-group-fullwidth'>
                  <Button className='btn-border-radius-left' onClick={this.modalFilter.bind(this, true)}><FilterOutlined /></Button>
                  <Popover placement="bottom" content={sortComponent} trigger="click">
                    <Button block className='btn-border-radius-right'><SortAscendingOutlined /> Sort</Button>
                  </Popover>
                </Button.Group>
              </BrowserView>
            </Col>

            <Col xs={24}>
              <BrowserView>
                <Desktop
                  access={access}
                  statusSiswa={statusSiswa}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalPenagguhan={this.modalPenagguhan}
                  modalDelete={this.modalDelete}
                  modalRestore={this.modalRestore}
                />
              </BrowserView>
              <MobileView>
                <Mobile
                  access={access}
                  statusSiswa={statusSiswa}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalPenagguhan={this.modalPenagguhan}
                  modalDelete={this.modalDelete}
                  modalRestore={this.modalRestore}
                />
              </MobileView>
            </Col>

          </Row>
        </div>

        {
          this.state.penangguhan.visible ?
            <Penangguhan
              data={this.state.penangguhan.data}
              visible={this.state.penangguhan.visible}
              hideModal={this.modalPenagguhan.bind(this, false, {})}
              fetchTable={this.fetchTable}
            /> : ""
        }

        {
          this.state.delete.visible ?
            <Delete
              data={this.state.delete.data}
              visible={this.state.delete.visible}
              hideModal={this.modalDelete.bind(this, false, {})}
              fetchTable={this.fetchTable}
            /> : ""
        }

        {
          this.state.restore.visible ?
            <Restore
              data={this.state.restore.data}
              visible={this.state.restore.visible}
              hideModal={this.modalRestore.bind(this, false, {})}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.filter.visible ?
            <Filter
              values={this.state.filter.values}
              visible={this.state.filter.visible}
              hideModal={this.modalFilter.bind(this, false)}
              setTempTableFilter={this.setTempTableFilter}
              setTableFilterFromTemp={this.setTableFilterFromTemp}
            /> : ""
        }
        {
          this.state.import.visible ?
            <Import
              visible={this.state.import.visible}
              hideModal={this.modalImport.bind(this, false)}
            /> : ""
        }
        {
          this.state.export.visible ?
            <Export
              visible={this.state.export.visible}
              hideModal={this.modalExport.bind(this, false)}
              statusSiswa={statusSiswa}
            /> : ""
        }
        <BackTop />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(SiswaIndex);
